/**
 * @generated SignedSource<<39e9b83c65d662c9d289a67f8633e476>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SubscriptionTier = "STANDARD" | "%future added value";
export type subscriptionCreateMutation$variables = {
  clientReferenceId: string;
  returnUrl: string;
  tier: SubscriptionTier;
};
export type subscriptionCreateMutation$data = {
  readonly subscriptionCreate: {
    readonly clientSecret: string;
  };
};
export type subscriptionCreateMutation = {
  response: subscriptionCreateMutation$data;
  variables: subscriptionCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "clientReferenceId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "returnUrl"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tier"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "clientReferenceId",
            "variableName": "clientReferenceId"
          },
          {
            "kind": "Variable",
            "name": "returnUrl",
            "variableName": "returnUrl"
          },
          {
            "kind": "Variable",
            "name": "tier",
            "variableName": "tier"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "SubscriptionCreateCheckoutSession",
    "kind": "LinkedField",
    "name": "subscriptionCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientSecret",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "subscriptionCreateMutation",
    "selections": (v3/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "subscriptionCreateMutation",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "cacheID": "edf62543e14b3704c211bbf12bc39290",
    "id": null,
    "metadata": {},
    "name": "subscriptionCreateMutation",
    "operationKind": "mutation",
    "text": "mutation subscriptionCreateMutation(\n  $tier: SubscriptionTier!\n  $clientReferenceId: String!\n  $returnUrl: String!\n) {\n  subscriptionCreate(input: {tier: $tier, clientReferenceId: $clientReferenceId, returnUrl: $returnUrl}) {\n    clientSecret\n  }\n}\n"
  }
};
})();

(node as any).hash = "614b1049303af1d7382a2ec725ceddd5";

export default node;
